export const DIRECTION_UP = "up";
export const DIRECTION_DOWN = "down";

export const LAYER_BOUND_FRONT = "front";
export const LAYER_BOUND_BACK = "back";

export const DROP_AREA_TOP = "top";
export const DROP_AREA_BOTTOM = "bottom";
export const DROP_AREA_CENTER = "center";

export const DIRECTION_ADJUSTMENT_MAP = {
  [DIRECTION_UP]: 1,
  [DIRECTION_DOWN]: -1,
};

export default {
  DIRECTION_UP,
  DIRECTION_DOWN,
  DIRECTION_ADJUSTMENT_MAP,
  LAYER_BOUND_FRONT,
  LAYER_BOUND_BACK,
  DROP_AREA_TOP,
  DROP_AREA_BOTTOM,
};
